import { useEffect, useState } from 'react';
import { type Theme, getSystemTheme } from '~/lib/utils';

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>('dark');
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Only run on the client side
    if (typeof window !== 'undefined') {
      if (import.meta.env.PROD) {
        // Force dark theme in production
        setThemeState('dark');
      } else {
        // Retrieve theme from localStorage or use system theme
        const storedTheme = localStorage.getItem('theme') as Theme | null;
        const effectiveTheme = storedTheme || getSystemTheme();
        setThemeState(effectiveTheme);
        document.documentElement.classList.toggle(
          'dark',
          effectiveTheme === 'dark'
        );
      }
      setIsLoaded(true);
    }
  }, []);

  const setTheme = (newTheme: Theme) => {
    // No-op in production mode
    if (import.meta.env.PROD) return;

    setThemeState(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.classList.toggle('dark', newTheme === 'dark');
  };

  return { theme, setTheme, isLoaded };
}
